//#region DEFAULT _DEFAULT_NGP_REPORT_PREVIEW_COLS
export const _DEFAULT_NGP_REPORT_PREVIEW_COLS: Readonly<Record<number, string>> = {
  [0]: 'icons',
  [1]: 'code',
  [2]: 'desc',
  [24]: 'sellPriIncl1',
  [16]: 'nominalGP',
  [31]: 'unitsYear',
};
//#endregion